import React from "react";
import { useAnimateInView } from "./useAnimateInView";
import BackgroundImage from "../Assets/TopAssigneesPage/bg.png";
import FirstPlace from "../Assets/TopAssigneesPage/first-place.svg";
import SecondPlace from "../Assets/TopAssigneesPage/second-place.svg";
import ThirdPlace from "../Assets/TopAssigneesPage/third-place.svg";
import { formatNumber } from "@SeemplicityDev/shared";

const getImageForPlace = (place: number): string => {
  switch (place) {
    case 1:
      return FirstPlace;
    case 2:
      return SecondPlace;
    case 3:
      return ThirdPlace;
    default:
      return "";
  }
};
interface TopAssigneesPageProps {
  data?: {
    opened_tickets_count: number;
    opened_findings_count: number;
    closed_tickets_count: number;
    closed_findings_count: number;
    assignees: {
      name: string;
      tickets_count: number;
      avg_ticket_time: number;
    }[];
  };
}

const TopAssigneesPage: React.FC<TopAssigneesPageProps> = ({ data }) => {
  const { ref, animateClassNames } = useAnimateInView();
  const {
    opened_tickets_count,
    opened_findings_count,
    closed_tickets_count,
    closed_findings_count,
    assignees,
  } = data || {};
  return (
    <div
      className={`eoy-page top-assignees-page ${animateClassNames}`}
      ref={ref}
    >
      <img src={BackgroundImage} alt="Background" className="bg-image" />
      <h2 className="page-title">
        Closed {formatNumber(closed_tickets_count)} Tickets for{" "}
        {formatNumber(closed_findings_count)} Findings*
      </h2>
      <h3 className="page-subtitle">
        You opened {formatNumber(opened_tickets_count)} tickets for{" "}
        {formatNumber(opened_findings_count)} findings{" "}
      </h3>
      <div className="assignees-container">
        {assignees?.map((assignee, index) => {
          return (
            <div
              className={`assignee-item assignee-item-${index + 1}`}
              key={assignee.name}
            >
              <div className="assignee-item-details">
                <span className="assignee-item-name">{assignee.name}</span>
                <span className="assignee-item-tickets-count">
                  {formatNumber(assignee.tickets_count)} Tickets
                </span>
                <span className="assignee-item-avg-ticket-time">
                  Ticket Avg Time: {formatNumber(assignee.avg_ticket_time) || 0}{" "}
                  days
                </span>
              </div>
              <div className="assignee-item-podium">
                <img
                  src={getImageForPlace(index + 1)}
                  alt={`Place ${index + 1}`}
                  className="podium-image"
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="disclaimer">*Some tickets were opened before 2025</div>
    </div>
  );
};

export default TopAssigneesPage;
